import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

/* 基本画面 */
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Help from '@/views/Help.vue'
import ErrorNotFound from '@/views/error/NotFound.vue'

/* 利用者画面 */
/* パスワード変更 */
import MemberChangePassword from '@/views/member/user/MemberChangePassword.vue'

/* 業務画面 */
/* ダッシュボード */
import MemberDashBoard from '@/views/member/MemberDashBoard.vue'
import MemberCsvTool from '@/views/member/csv_tool/MemberCsvTool.vue'

/* 見積 */
import MemberEstimateEdit from '@/views/member/estimate/MemberEstimateEdit.vue'
import MemberEstimateList from '@/views/member/estimate/MemberEstimateList.vue'

/* 請書 */
import MemberConfirmationEdit from '@/views/member/confirmation/MemberConfirmationEdit.vue'
import MemberConfirmationList from '@/views/member/confirmation/MemberConfirmationList.vue'

/* 検査依頼 */
import MemberRequestEdit from '@/views/member/request/MemberRequestEdit.vue'
import MemberRequestList from '@/views/member/request/MemberRequestList.vue'
import MemberRequestCsv from '@/views/member/request/MemberRequestCsv.vue'
import MemberRequestCsvConvert from '@/views/member/request/MemberRequestCsvConvert.vue'

/* 検査 */
import MemberUninspectedList from '@/views/member/uninspected/MemberUninspectedList.vue'
import MemberInspectionList from '@/views/member/inspection/MemberInspectionList.vue'

/* 報告書 */
import MemberUnreportedList from '@/views/member/unreported/MemberUnreportedList.vue'
import MemberReportEdit from '@/views/member/report/MemberReportEdit.vue'
import MemberReportList from '@/views/member/report/MemberReportList.vue'
import MemberReportCsvExport from '@/views/member/report/MemberReportCsvExport.vue'
import MemberReportCsvImport from '@/views/member/report/MemberReportCsvImport.vue'

/* 請求 */
import MemberUnclaimedList from '@/views/member/unclaimed/MemberUnclaimedList.vue'
import MemberInvoiceEdit from '@/views/member/invoice/MemberInvoiceEdit.vue'
import MemberInvoiceList from '@/views/member/invoice/MemberInvoiceList.vue'
import MemberAgencyInvoiceEdit from '@/views/member/agency/MemberAgencyInvoiceEdit.vue'
import MemberAgencyInvoiceList from '@/views/member/agency/MemberAgencyInvoiceList.vue'
import MemberTotalInvoiceEdit from '@/views/member/total/MemberTotalInvoiceEdit.vue'
import MemberTotalInvoiceList from '@/views/member/total/MemberTotalInvoiceList.vue'

/* データ連携 */
import MemberExport from '@/views/member/export/MemberExport.vue'


/* マスタ */

/* 顧客マスタ */
import MasterCustomerList from '@/views/master/customer/MasterCustomerList.vue'

/* 顧客価格マスタ */
import MasterCustomerPriceList from '@/views/master/customer_price/MasterCustomerPriceList.vue'
import MasterCustomerPriceCopy from '@/views/master/customer_price/MasterCustomerPriceCopy.vue'

/* 検査分類マスタ */
import MasterClassificationList from '@/views/master/classification/MasterClassificationList.vue'

/* 検査項目マスタ */
import MasterInspectionList from '@/views/master/inspection/MasterInspectionList.vue'

/* 報告書マスタ */
import MasterReportTypeList from '@/views/master/report_type/MasterReportTypeList.vue'

/* 部門マスタ */
import MasterDepartmentList from '@/views/master/department/MasterDepartmentList.vue'

/* 部署マスタ */
import MasterSectionList from '@/views/master/section/MasterSectionList.vue'

/* ユーザマスタ */
import MasterUserList from '@/views/master/user/MasterUserList.vue'

/* メール送信テスト */
import MasterMailTest from '@/views/master/mail/MasterMailTest.vue'

/* ログイン状態 */
import { LoginStateModule } from '@/store/modules/LoginStateModule'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  /* トップページ */
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: false,
    },
  },
  /* ログインページ */
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "ログイン",
      requiresAuth: false,
      breadcrumbs: [
        { text: "Home", to: "/", },
        { text: "ログイン", to: "/login", },
      ],
    },
  },
  /* ヘルプ */
  {
    path: "/help",
    name: "Help",
    component: Help,
    meta: {
      title: "ヘルプ",
      requiresAuth: false,
      breadcrumbs: [
        { text: "Home", to: "/", },
        { text: "ヘルプ", to: "/help", },
      ],
    },
  },

  /* メンバー向け画面 */

  /* ダッシュボード */
  {
    path: "/member/dashbord",
    name: "MemberDashBoard",
    component: MemberDashBoard,
    meta: {
      title: "DashBoard",
      requiresAuth: true,
      require: "login",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
      ],
    },
  },

  /* パスワード変更 */
  {
    path: "/member/change_password",
    name: "MemberChangePassword",
    component: MemberChangePassword,
    meta: {
      title: "パスワード変更",
      requiresAuth: true,
      require: "login",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "パスワード変更", to: "/member/change_password", },
      ],
    },
  },

  /* CSVツール(最終的には削除) */
  {
    path: "/member/csv_tool",
    name: "MemberCsvTool",
    component: MemberCsvTool,
    meta: {
      title: "CSVツール",
      requiresAuth: true,
      require: "login",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "CSVツール", to: "/member/csv_tool", },
      ],
    },
  },

  /* 見積 */

  /* 見積書作成 */
  {
    path: "/member/estimate/new",
    name: "MemberEstimateNew",
    component: MemberEstimateEdit,
    meta: {
      title: "見積書作成",
      requiresAuth: true,
      require: "tool.estimate.new",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "見積一覧", to: "/member/estimate/list", },
        { text: "見積書作成", to: "/member/estimate/new", },
      ],
    },
  },
  /* 見積書編集 */
  {
    path: "/member/estimate/edit/:no",
    name: "MemberEstimateEdit",
    component: MemberEstimateEdit,
    meta: {
      title: "見積書編集",
      requiresAuth: true,
      require: "tool.estimate.edit",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "見積一覧", to: "/member/estimate/list", },
        { text: "見積書編集", to: "/member/estimate/edit", },
      ],
    },
  },
  /* 見積書一覧 */
  {
    path: "/member/estimate/list",
    name: "MemberEstimateList",
    component: MemberEstimateList,
    meta: {
      title: "見積書一覧",
      requiresAuth: true,
      require: "tool.estimate.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "見積一覧", to: "/member/estimate/list", },
      ],
    },
  },



  /* 請書 */

  /* 請書作成 */
  {
    path: "/member/confirmation/new",
    name: "MemberConfirmationNew",
    component: MemberConfirmationEdit,
    meta: {
      title: "請書作成",
      requiresAuth: true,
      require: "tool.confirmation.new",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "請書一覧", to: "/member/confirmation/list", },
        { text: "請書作成", to: "/member/confirmation/new", },
      ],
    },
  },
  /* 請書編集 */
  {
    path: "/member/confirmation/edit/:no",
    name: "MemberConfirmationEdit",
    component: MemberConfirmationEdit,
    meta: {
      title: "請書編集",
      requiresAuth: true,
      require: "tool.confirmation.edit",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "請書一覧", to: "/member/confirmation/list", },
        { text: "請書編集", to: "/member/confirmation/edit", },
      ],
    },
  },
  /* 請書一覧 */
  {
    path: "/member/confirmation/list",
    name: "MemberConfirmationList",
    component: MemberConfirmationList,
    meta: {
      title: "請書一覧",
      requiresAuth: true,
      require: "tool.confirmation.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "請書一覧", to: "/member/confirmation/list", },
      ],
    },
  },


  /* 検査依頼登録 */
  {
    path: "/member/request/new",
    name: "MemberRequestNew",
    component: MemberRequestEdit,
    meta: {
      title: "検査依頼作成",
      requiresAuth: true,
      require: "tool.request.new",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "検査依頼一覧", to: "/member/request/list", },
        { text: "検査依頼作成", to: "/member/request/new", },
      ],
    },
  },
  /* 検査依頼編集 */
  {
    path: "/member/request/edit/:no",
    name: "MemberRequestEdit",
    component: MemberRequestEdit,
    meta: {
      title: "検査依頼編集",
      requiresAuth: true,
      require: "tool.request.edit",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "検査依頼一覧", to: "/member/request/list", },
        { text: "検査依頼編集", to: "/member/request/edit", },
      ],
    },
  },
  /* 検査依頼一覧 */
  {
    path: "/member/request/list",
    name: "MemberRequestList",
    component: MemberRequestList,
    meta: {
      title: "検査依頼一覧",
      requiresAuth: true,
      require: "tool.request.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "検査依頼一覧", to: "/member/request/list", },
      ],
    },
  },
  /* 検査依頼CSV登録 */
  {
    path: "/member/request/csv",
    name: "MemberRequestCsv",
    component: MemberRequestCsv,
    meta: {
      title: "検査依頼CSV登録",
      requiresAuth: true,
      require: "tool.request.csv",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "検査依頼一覧", to: "/member/request/list", },
        { text: "検査依頼CSV登録", to: "/member/request/csv", },
      ],
    },
  },
  /* 検査依頼受付CSV変換 */
  {
    path: "/member/request/csv_convert",
    name: "MemberRequestCsvConvert",
    component: MemberRequestCsvConvert,
    meta: {
      title: "検査依頼受付CSV変換",
      requiresAuth: true,
      require: "tool.request.csv_convert",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "検査依頼一覧", to: "/member/request/list", },
        { text: "検査依頼受付CSV変換", to: "/member/request/csv_convert", },
      ],
    },
  },
  

  /* 検査 */

  /* 未検査一覧 */
  {
    path: "/member/uninspected/list",
    name: "MemberUninspectedList",
    component: MemberUninspectedList,
    meta: {
      title: "未検査一覧",
      requiresAuth: true,
      require: "tool.uninspected.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "未検査一覧", to: "/member/uninspected/list", },
      ],
    },
  },

  /* 検査一覧 */
  {
    path: "/member/inspection/list",
    name: "MemberInspectionList",
    component: MemberInspectionList,
    meta: {
      title: "検査一覧",
      requiresAuth: true,
      require: "tool.inspection.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "検査一覧", to: "/member/inspection/list", },
      ],
    },
  },

  
  /* 報告書 */

  /* 未報告一覧 */
  {
    path: "/member/unreported/list",
    name: "MemberUnreportedList",
    component: MemberUnreportedList,
    meta: {
      title: "未報告一覧",
      requiresAuth: true,
      require: "tool.unreported.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "未報告一覧", to: "/member/unreported/list", },
      ],
    },
  },
  /* 報告書作成 */
  {
    path: "/member/report/new",
    name: "MemberReportNew",
    component: MemberReportEdit,
    meta: {
      title: "報告書作成",
      requiresAuth: true,
      require: "tool.report.new",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "報告書一覧", to: "/member/report/list", },
        { text: "報告書作成", to: "/member/report/new", },
      ],
    },
  },
  /* 報告書編集 */
  {
    path: "/member/report/edit/:no",
    name: "MemberReportEdit",
    component: MemberReportEdit,
    meta: {
      title: "報告書編集",
      requiresAuth: true,
      require: "tool.report.edit",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "報告書一覧", to: "/member/report/list", },
        { text: "報告書編集", to: "/member/report/edit", },
      ],
    },
  },
  /* 報告書一覧 */
  {
    path: "/member/report/list",
    name: "MemberReportList",
    component: MemberReportList,
    meta: {
      title: "報告書一覧",
      requiresAuth: true,
      require: "tool.report.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "報告書一覧", to: "/member/report/list", },
      ],
    },
  },
  /* 報告CSVエクスポート */
  {
    path: "/member/report/csv_export",
    name: "MemberReportCsvExport",
    component: MemberReportCsvExport,
    meta: {
      title: "報告CSVエクスポート",
      requiresAuth: true,
      require: "tool.report.csv_export",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "報告書一覧", to: "/member/report/list", },
        { text: "報告CSVエクスポート", to: "/member/report/csv_export", },
      ],
    },
  },
  /* 報告CSVインポート */
  {
    path: "/member/report/csv_import",
    name: "MemberReportCsvImport",
    component: MemberReportCsvImport,
    meta: {
      title: "報告CSVインポート",
      requiresAuth: true,
      require: "tool.report.csv_import",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "報告書一覧", to: "/member/report/list", },
        { text: "報告CSVインポート", to: "/member/report/csv_import", },
      ],
    },
  },


  /* 請求 */

  /* 未請求一覧 */
  {
    path: "/member/unclaimed/list",
    name: "MemberUnclaimedList",
    component: MemberUnclaimedList,
    meta: {
      title: "未請求一覧",
      requiresAuth: true,
      require: "tool.unclaimed.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "未請求一覧", to: "/member/unclaimed/list", },
      ],
    },
  },
  /* 請求書作成 */
  {
    path: "/member/invoice/new",
    name: "MemberInvoiceNew",
    component: MemberInvoiceEdit,
    meta: {
      title: "請求書作成",
      requiresAuth: true,
      require: "tool.invoice.new",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "未請求一覧", to: "/member/unclaimed/list", },
        { text: "請求書作成", to: "/member/invoice/new", },
      ],
    },
  },
  /* 請求書編集 */
  {
    path: "/member/invoice/edit/:no",
    name: "MemberInvoiceEdit",
    component: MemberInvoiceEdit,
    meta: {
      title: "請求書編集",
      requiresAuth: true,
      require: "tool.invoice.edit",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "請求書一覧", to: "/member/invoice/list", },
        { text: "請求書編集", to: "/member/invoice/edit", },
      ],
    },
  },
  /* 請求書一覧 */
  {
    path: "/member/invoice/list",
    name: "MemberInvoiceList",
    component: MemberInvoiceList,
    meta: {
      title: "請求書一覧",
      requiresAuth: true,
      require: "tool.invoice.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "請求書一覧", to: "/member/invoice/list", },
      ],
    },
  },
  /* 代理店請求書作成 */
  {
    path: "/member/agency/invoice/new",
    name: "MemberAgencyInvoiceNew",
    component: MemberAgencyInvoiceEdit,
    meta: {
      title: "代理店請求書作成",
      requiresAuth: true,
      require: "tool.agency.invoice.new",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "代理店請求一覧", to: "/member/agency/invoice/list", },
        { text: "代理店請求書作成", to: "/member/agency/invoice/new", },
      ],
    },
  },
  /* 代理店請求書編集 */
  {
    path: "/member/agency/invoice/edit/:no",
    name: "MemberAgencyInvoiceEdit",
    component: MemberAgencyInvoiceEdit,
    meta: {
      title: "代理店請求書編集",
      requiresAuth: true,
      require: "tool.agency.invoice.edit",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "代理店請求一覧", to: "/member/agency/invoice/list", },
        { text: "代理店請求書編集", to: "/member/agency/invoice/edit", },
      ],
    },
  },
  /* 代理店請求一覧 */
  {
    path: "/member/agency/invoice/list",
    name: "MemberAgencyInvoiceList",
    component: MemberAgencyInvoiceList,
    meta: {
      title: "代理店請求一覧",
      requiresAuth: true,
      require: "tool.agency.invoice.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "代理店請求一覧", to: "/member/agency/invoice/list", },
      ],
    },
  },
  /* 合算請求書作成 */
  {
    path: "/member/total/invoice/new",
    name: "MemberTotalInvoiceNew",
    component: MemberTotalInvoiceEdit,
    meta: {
      title: "合算請求書作成",
      requiresAuth: true,
      require: "tool.total.invoice.new",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "合算請求一覧", to: "/member/total/invoice/list", },
        { text: "合算請求書作成", to: "/member/total/invoice/new", },
      ],
    },
  },
  /* 合算請求書編集 */
  {
    path: "/member/total/invoice/edit/:no",
    name: "MemberTotalInvoiceEdit",
    component: MemberTotalInvoiceEdit,
    meta: {
      title: "合算請求書編集",
      requiresAuth: true,
      require: "tool.total.invoice.edit",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "合算請求一覧", to: "/member/total/invoice/list", },
        { text: "合算請求書編集", to: "/member/total/invoice/edit", },
      ],
    },
  },
  /* 合算請求一覧 */
  {
    path: "/member/total/invoice/list",
    name: "MemberTotalInvoiceList",
    component: MemberTotalInvoiceList,
    meta: {
      title: "合算請求一覧",
      requiresAuth: true,
      require: "tool.total.invoice.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "合算請求一覧", to: "/member/total/invoice/list", },
      ],
    },
  },


  /* その他 */

  /* データ連携 */
  {
    path: "/member/export",
    name: "MemberExport",
    component: MemberExport,
    meta: {
      title: "データ連携",
      requiresAuth: true,
      require: "tool.export",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "データ連携", to: "/member/export", },
      ],
    },
  },

  /* マスタ */

  /* 顧客マスタ */
  {
    path: "/master/customer/list",
    name: "MasterCustomerList",
    component: MasterCustomerList,
    meta: {
      title: "顧客マスタ",
      requiresAuth: true,
      require: "master.customer.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "顧客マスタ", to: "/master/customer/list", },
      ],
    },
  },
  /* 顧客価格マスタ */
  {
    path: "/master/customer_price/list",
    name: "MasterCustomerPriceList",
    component: MasterCustomerPriceList,
    meta: {
      title: "顧客価格マスタ",
      requiresAuth: true,
      require: "master.customer_price.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "顧客価格マスタ", to: "/master/customer_price/list", },
      ],
    },
  },
  /* 顧客価格マスタ複写 */
  {
    path: "/master/customer_price/copy",
    name: "MasterCustomerPriceCopy",
    component: MasterCustomerPriceCopy,
    meta: {
      title: "顧客価格マスタ複写",
      requiresAuth: true,
      require: "master.customer_price.copy",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "顧客価格マスタ複写", to: "/master/customer_price/copy", },
      ],
    },
  },
  /* 検査分類マスタ */
  {
    path: "/master/classification/list",
    name: "MasterClassificationList",
    component: MasterClassificationList,
    meta: {
      title: "検査分類マスタ",
      requiresAuth: true,
      require: "master.classification.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "検査分類マスタ", to: "/master/classification/list", },
      ],
    },
  },
  /* 検査項目マスタ */
  {
    path: "/master/inspection/list",
    name: "MasterInspectionList",
    component: MasterInspectionList,
    meta: {
      title: "検査項目マスタ",
      requiresAuth: true,
      require: "master.inspection.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "検査項目マスタ", to: "/master/inspection/list", },
      ],
    },
  },
  /* 報告書マスタ */
  {
    path: "/master/report_type/list",
    name: "MasterReportTypeList",
    component: MasterReportTypeList,
    meta: {
      title: "報告書マスタ",
      requiresAuth: true,
      require: "master.report_type.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "報告書マスタ", to: "/master/report_type/list", },
      ],
    },
  },
  /* 部門マスタ */
  {
    path: "/master/department/list",
    name: "MasterDepartmentList",
    component: MasterDepartmentList,
    meta: {
      title: "部門マスタ",
      requiresAuth: true,
      require: "master.department.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "部門マスタ", to: "/master/department/list", },
      ],
    },
  },
  /* 部署マスタ */
  {
    path: "/master/section/list",
    name: "MasterSectionList",
    component: MasterSectionList,
    meta: {
      title: "部署マスタ",
      requiresAuth: true,
      require: "master.section.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "部署マスタ", to: "/master/section/list", },
      ],
    },
  },
  /* ユーザマスタ */
  {
    path: "/master/user/list",
    name: "MasterUserList",
    component: MasterUserList,
    meta: {
      title: "ユーザマスタ",
      requiresAuth: true,
      require: "master.user.list",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "ユーザマスタ", to: "/master/user/list", },
      ],
    },
  },
  /* メール送信テスト */
  {
    path: "/master/mail/test",
    name: "MasterMailTest",
    component: MasterMailTest,
    meta: {
      title: "メール送信テスト",
      requiresAuth: true,
      require: "master.mail.test",
      breadcrumbs: [
        { text: "DashBoard", to: "/member/dashbord", },
        { text: "メール送信テスト", to: "/master/mail/test", },
      ],
    },
  },

  /* エラー処理画面 */

  /* ページなし */
  {
    path: "*",
    name: "ErrorNotFound",
    component: ErrorNotFound,
    meta: {
      title: "エラー",
      requiresAuth: false,
    }
  },
]

/**
 * VueRouterの設定
 */
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

/**
 * ルーティング前処理
 */
router.beforeEach((to, from, next) => {
  /* タイトル設定 */
  window.document.title = (to.meta.title === undefined ? "" : to.meta.title + " - ") + "食品検査システム"

  /* ログイン認証チェック */
  if (to.meta.requiresAuth && !LoginStateModule.isLogin) {
    // TODO: 権限ロールチェックが必要
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    })      
  } else {
    next() 
  }
})

export default router
